import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FeatureSelectors from "../redux/selectors/featureSelectors.js";

// Feature flags are simple on/off toggles (no AB-testing/steps), typically used
// for temporary, ticket-scoped switches such as migration blocks.
export const useFeatureFlag = (featureFlagName, genericFeatureFlagName) => {
  const activeFeatureFlags = useSelector(FeatureSelectors.activeFeatureFlags);

  const [isInFeatureFlag, setIsInFeatureFlag] = useState(false);

  const findIfIsActiveFeatureFlag = useCallback(
    (featureFlagName, genericFeatureFlagName) => {
      if (!activeFeatureFlags?.length) return false;

      return activeFeatureFlags.some(featureFlag => {
        const featureFlagId = featureFlag?.id.toString().toLowerCase();

        if (!featureFlagId) return false;

        return (
          featureFlagId === featureFlagName?.toLowerCase() ||
          featureFlagId === genericFeatureFlagName?.toLowerCase()
        );
      });
    },
    [activeFeatureFlags]
  );

  useEffect(() => {
    let isActiveFeatureFlag = findIfIsActiveFeatureFlag(
      featureFlagName,
      genericFeatureFlagName
    );

    setIsInFeatureFlag(isActiveFeatureFlag);
  }, [
    featureFlagName,
    genericFeatureFlagName,
    findIfIsActiveFeatureFlag,
    setIsInFeatureFlag
  ]);

  return isInFeatureFlag;
};
